"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("../colors");

var _constants = require("../constants");

var attunedDarkTheme = {
  mode: _constants.DARK_MODE,
  background: {
    default: _colors.BACKGROUND_DARK,
    login: _colors.NAVY14
  },
  action: {
    hover: 'rgba(0, 0, 0, 0.2)'
  },
  primary: {
    main: _colors.LIGHT_BLUE,
    200: _colors.LIGHT_BLUE6,
    400: _colors.MID_BLUE2
  },
  secondary: {
    main: '#fff'
  },
  font: {
    primary: _colors.LIGHT_BLUE,
    secondary: 'white',
    tertiary: _colors.LIGHT_BLUE,
    description: _colors.LIGHT_BLUE,
    disabled: {
      primary: 'grey'
    },
    pageHeader: {
      primary: 'white'
    }
  },
  inputField: {
    primary: _colors.NAVY12
  },
  hr: {
    primary: _colors.DARK_GRAY
  },
  content: {
    primary: _colors.NAVY4,
    secondary: _colors.NAVY3
  },
  popover: {
    primary: _colors.NAVY4,
    hover: {
      primary: _colors.NAVY
    }
  },
  title: {
    primary: _colors.NAVY,
    background: _colors.NAVY,
    border: '1px solid transparent'
  },
  paginatedLoadingMessage: {
    background: {
      primary: _colors.DARK_NAVY
    },
    text: {
      primary: _colors.MID_BLUE
    }
  },
  table: {
    row: {
      hover: {
        primary: _colors.NAVY5
      },
      border: 'none'
    },
    filter: {
      primary: _colors.NAVY,
      secondary: _colors.NAVY12
    },
    card: {
      background: {
        primary: _colors.MID_BLUE4
      }
    },
    selected: {
      background: {
        primary: _colors.NAVY9
      }
    }
  },
  specialButton: {
    primary: _colors.NAVY9,
    secondary: _colors.NAVY13
  },
  paper: {
    background: {
      secondary: _colors.LIGHT_GRAY
    }
  },
  rectangularOption: {
    font: {
      primary: _colors.LIGHT_BLUE,
      secondary: _colors.LIGHT_BLUE
    },
    border: {
      primary: _colors.NAVY5,
      secondary: _colors.LIGHT_BLUE
    },
    background: {
      primary: _colors.DARK_NAVY4,
      secondary: _colors.NAVY5
    }
  },
  skeleton: {
    primary: 'rgba(248, 248, 248, 0.8)'
  },
  onboardingTour: {
    background: _colors.ONBOARDING_BLUE,
    backButtonText: _colors.ONBOARDING_BLUE2,
    nextButton: _colors.LIGHT_GRAY2,
    nextButtonText: _colors.NAVY15
  },
  nestedSubmenu: {
    primary: '#2F2F2F'
  },
  tooltip: {
    primary: _colors.DARK_NAVY6,
    color: '#ffffff'
  },
  footerIcon: {
    default: _colors.ACCENT_BLUE
  },
  chip: {
    primary: _colors.LIGHT_BLUE6
  },
  success: {
    main: _colors.GREEN_PRIMARY,
    contrastText: '#fff'
  },
  info: {
    main: _colors.ONBOARDING_BLUE,
    contrastText: '#fff'
  },
  error: {
    main: _colors.ORANGE1,
    contrastText: '#fff'
  },
  warning: {
    main: _colors.YELLOW1,
    contrastText: _colors.DARK_NAVY6
  }
};
var _default = attunedDarkTheme;
exports.default = _default;